import { useState } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import { useAgora } from '../lib/useAgora'
import { dataISOLocal } from '../pedidos/precos'
import { carregarDadosAvisos } from '../avisos/carregar'
import { montarAvisos, textoDoTotal } from '../avisos/regras'
import { lerDispensados, dispensarCliente } from '../avisos/dispensados'
import FolhaDeAvisos from './FolhaDeAvisos'

// Spec 2026-10-06 (ciclo 2C): sino em ouro velho no cabecalho de TODAS as
// telas (grande no Inicio). useAgora: vira o dia e a hora com o app aberto.
export default function Sininho({ grande }: { grande: boolean }) {
  const agora = useAgora()
  const hoje = dataISOLocal(agora)
  // [hoje]: a janela de 7 dias anda junto com o dia.
  const dados = useLiveQuery(() => carregarDadosAvisos(new Date()), [hoje])
  const [dispensados, setDispensados] = useState(() => lerDispensados())
  const [aberto, setAberto] = useState(false)
  if (!dados) return null
  const avisos = montarAvisos(dados, agora, dispensados)
  const bolinha = textoDoTotal(avisos.total)

  return (
    <>
      {/* Pedido dela 06/10: o sino da frente igual ao do titulo da folha (emoji
          normal, sem o dourado que o deixava grosseiro). Toque segue 40px. */}
      <button type="button" onClick={() => setAberto(true)} aria-label="Avisos" data-testid="sininho"
        className="relative shrink-0 -my-1 min-w-[40px] min-h-[40px] flex items-center justify-center">
        <span aria-hidden="true" className={`leading-none ${grande ? 'text-lg' : 'text-base'}`}>🔔</span>
        {bolinha && (
          <span data-testid="avisos-total"
            className="absolute top-1.5 right-1 min-w-[15px] h-[15px] px-[3px] rounded-full bg-red-600 ring-1 ring-white/70 text-white text-[9px] font-bold leading-none flex items-center justify-center">
            {bolinha}
          </span>
        )}
      </button>
      {aberto && (
        <FolhaDeAvisos avisos={avisos} clientes={dados.clientes} agora={agora}
          aoFechar={() => setAberto(false)}
          aoDispensar={(dia, id) => setDispensados((atual) => dispensarCliente(atual, dia, id))} />
      )}
    </>
  )
}
